import HourRecordAudit from './src/main';

/* istanbul ignore next */
HourRecordAudit.install = function(Vue) {
  Vue.component(HourRecordAudit.name, HourRecordAudit);
};

export default HourRecordAudit;
